import {Component, HostListener, OnInit, Renderer2} from '@angular/core';
import {BodyStyleService, UserService} from './core/services';
import {FaIconLibrary} from "@fortawesome/angular-fontawesome";
import { faInfoCircle as fasInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'aml-comita';

  constructor(private userService: UserService,
              library: FaIconLibrary,
              private bodyService: BodyStyleService,
              private renderer: Renderer2) {
    library.addIcons(fasInfoCircle);
  }

  ngOnInit() {
    document.getElementById('spin_start-page_load_aml').style.visibility = "hidden";
    this.userService.tryAuth();
    this.bodyService.init();
    this.bodyService.setStyle.subscribe(style => {
      this.renderer.setStyle(document.body, style.styleName, style.styleData);
    });
  }

  // Временное решение для обновления UI. Пока что футер будет только для админ версии, далее это убрать
  // и сделать футер общим
  isAdmin() {
    return sessionStorage.getItem('userRole') === 'admin'
  }

  @HostListener('click')
  @HostListener('keydown')
  @HostListener('mouseleave')
  @HostListener('blur')
  @HostListener('focus')
  @HostListener('window:scroll')
  @HostListener('window:resize')
  onClick() {
    this.userService.userActions$.next('user action');
  }
}
